import { makeAutoObservable } from 'mobx'
import { type PageLayoutStore } from 'shared/layout'
import type { IEntitiesStore } from 'entities/EntitiesExport'

export class CampaignsPageStore {
  constructor(private _pageLayoutStore: PageLayoutStore, private _entities: IEntitiesStore) {
    makeAutoObservable(this)
  }

  get pageLayoutStore() {
    return this._pageLayoutStore
  }

  get entities() {
    return this._entities
  }
}
